import { render, staticRenderFns } from "./MilestoneStatistics.vue?vue&type=template&id=91ad0580&"
import script from "./MilestoneStatistics.vue?vue&type=script&lang=js&"
export * from "./MilestoneStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports